module.exports = {
  email: 'salkhon050@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/salkhon',
    },
    {
      name: 'Kaggle',
      url: 'https://www.kaggle.com/salmankhondker',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/salkhon/',
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/salman.khondker',
    },
    {
      name: 'Google Scholar',
      url: 'https://scholar.google.com/citations?user=BWTGEy4AAAAJ',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    // {
    //   name: 'News',
    //   url: '/#news',
    // },
    {
      name: 'Skills',
      url: '/#skills',
    },
    {
      name: 'Publications',
      url: '/#publications',
    },
    {
      name: 'Awards',
      url: '/#awards',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
    blackNavy: '#000814',
    yellow: '#FFEF5D',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
